import React from 'react';
import './App.css';

import Homepage from './pages/homepage/HomepageComponent';

function App() {
  return (
    <div >
      <Homepage/>
    </div>
  );
}

export default App;
